import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const scrollDirection = ({ scrollDirection }) =>
    scrollDirection &&
    `
    ${
        scrollDirection === "vertical"
            ? `
        overflow-x: hidden;
        overflow-y: auto;
    `
            : `
        overflow-x: auto;
        overflow-y: hidden;
    `
    };
`;

const scrollbar = ({ scrollbar }) =>
    !scrollbar &&
    `
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const ignoredProps = ["scrollDirection", "scrollbar"];
const ScrollableBox = styled("div", { shouldForwardProp: (prop) => ignoredProps.indexOf(prop) === -1 })`
    -webkit-overflow-scrolling: touch;

    ${scrollDirection};
    ${scrollbar};
`;

ScrollableBox.propTypes = {
    scrollDirection: PropTypes.oneOf(["vertical", "horizontal"]),
    scrollbar: PropTypes.bool,
};

ScrollableBox.defaultProps = {
    scrollDirection: "vertical",
    scrollbar: false,
};

export default ScrollableBox;
